import { Divider } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = Omit<ComponentPropsWithoutRef<typeof Divider>, 'type'>

export const OverlayDivider: FC<Props> = ({ className, ...props }) => {
  return (
    <Divider
      {...props}
      type="vertical"
      className={clsx(['mt-1 border-white text-white opacity-80', className])}
    />
  )
}
